import React, { useState } from "react";
import { Link } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [notice, setNotice] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!email.trim()) {
      setNotice(
        "Enter your work email so we can direct you to the right support channel."
      );
      return;
    }

    setNotice(
      "Client portal access is provisioned directly by the Operating Software team. We will follow up through the shared support process."
    );
    setEmail("");
  };

  return (
    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4 login-shell">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-7 d-flex flex-column align-items-center justify-content-center">
            <div className="d-flex justify-content-center py-4">
              <Link
                to="/"
                className="logo d-flex align-items-center w-auto login-brand-link"
              >
                <img src="assets/img/logo.png" alt="Operating Software logo" />
                <span className="d-none d-lg-block">Operating Software</span>
              </Link>
            </div>

            <div className="card mb-3 login-card">
              <div className="card-body">
                <div className="pt-4 pb-2 text-center">
                  <h1 className="card-title pb-0 fs-4">Client Portal Access</h1>
                  <p className="small mb-0">
                    Portal access is shared directly with approved client teams.
                    Leave your email and we will guide you to the right next
                    step.
                  </p>
                </div>

                <form className="row g-3" onSubmit={handleSubmit}>
                  <div className="col-12">
                    <label htmlFor="client-email" className="form-label">
                      Work Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      id="client-email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                      placeholder="name@company.com"
                    />
                  </div>

                  <div className="col-12">
                    <button className="btn btn-primary w-100" type="submit">
                      Request Access Guidance
                    </button>
                  </div>

                  {notice ? (
                    <div className="col-12">
                      <div className="sent-message contact-status visible">
                        {notice}
                      </div>
                    </div>
                  ) : null}
                </form>

                <div className="text-center mt-4">
                  <Link to="/" className="read-more">
                    <span>Back to the website</span>
                    <i className="bi bi-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
